import React, { useState } from "react";
import "./index.scss";
import { CircleCheck } from "../../../../../assets/images/svg/svg";
import { Link, useLocation } from "react-router-dom";
import { formatAmount } from "../../../../../utils/helper";

const ProductVariantDetails = ({ product, isVisible, showPremium, type }) => {
  const [showAllBenefits, setShowAllBenefits] = useState(false);
  const location = useLocation();

  const handelTogglebenefits = () => {
    setShowAllBenefits((prev) => !prev);
  };

  const initialBenefitCount = 3;
  const benefitToShow = showAllBenefits
    ? product?.product_benefits
    : product?.product_benefits?.slice(0, initialBenefitCount) || [];

  console.log(isVisible);

  return (
    <div
      className="insurance--detail--wrapper"
      key={product.product_name}
    >
      <div className="details--wrapper--header">
        <div className="details--header--title">
          <h1 className="details--header--title--text">
            {product.product_name}
          </h1>
          <h3 className="details--header--subtitle--text">
            {type === "UMBRELLA" ? `Cover ${formatAmount(product.cover_amount)}` : (product?.pspOem?.name || product?.psp_name)}
          </h3>
        </div>
        {/* {showPremium && ( */}
        <h3 className="details--header--price">
          {formatAmount(product.final_premium)}
        </h3>
        {/* )} */}
      </div>
      {isVisible && benefitToShow.length > 0 && (
        <div className="details--body--wrapper">
          <ul className="body--list">
            {benefitToShow?.map((list, index) => (
              <li key={index}>
                <CircleCheck />
                <span className="body--list--text">{list?.name}</span>
              </li>
            ))}
            {product?.product_benefits?.length > initialBenefitCount && (
              <Link
                to={`${location.pathname}${location.search}`}
                className="body--list--card-link"
                onClick={handelTogglebenefits}
              >
                {showAllBenefits ? "View Less" : "View All"}
              </Link>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProductVariantDetails;
